import { useCallback, useState } from 'react';
import ConfirmDialog from './ConfirmDialog';

const useConfirm = () => {
	const [options, setOptions] = useState(null);

	const confirm = useCallback((message, config = {}) => {
		return new Promise((resolve) => {
			setOptions({ message, ...config, resolve });
		});
	}, []);

	const handleClose = (result) => {
		options?.resolve(result);
		setOptions(null);
	};

	const confirmDialog = options ? (
		<ConfirmDialog
			open
			title={options.title}
			message={options.message}
			confirmText={options.confirmText}
			cancelText={options.cancelText}
			confirmColor={options.confirmColor}
			onConfirm={() => handleClose(true)}
			onCancel={() => handleClose(false)}
		/>
	) : null;

	return { confirm, confirmDialog };
};

export default useConfirm;
